import Vue from "vue";
Vue.mixin({
    methods: {
        showMargins() {
            class marginHighlight {
                static get MIN_MARGIN() {
                    return 20;
                }
                constructor(item, mt, mb) {
                    this.offset = GiuliaWebSite.helpers.getOffset(item);
                    this.height = item.getBoundingClientRect().height;
                    this.width = item.getBoundingClientRect().width;
                    mt > 0 ? this.append(mt, 'top') : this.append(mb, 'bottom');
                }
                append(margin, type) {
                    let newMargin = document.createElement('div');
                    newMargin.classList.add('d-flex', 'align-items-center', 'justify-content-center');
                    newMargin.style.fontSize = '14px';
                    newMargin.style.fontFamily = 'Futura';
                    newMargin.style.fontWeight = '450';
                    newMargin.style.height = margin + 'px';
                    newMargin.style.position = 'absolute';
                    newMargin.style.backgroundColor = 'rgba(255, 0, 0, 0.1)';
                    newMargin.style.zIndex = 1000;
                    newMargin.style.left = this.offset.left + 'px';
                    newMargin.style.width = this.width + 'px';
                    newMargin.style.top = (type == 'top' ? this.offset.top - margin : this.offset.top + this.height) + 'px';
                    newMargin.style.textAlign = 'center';
                    newMargin.innerHTML = margin + 'px';
                    document.body.appendChild(newMargin);
                }
            }

            document.querySelectorAll('*').forEach(item => {
                const style = getComputedStyle(item);
                if(style.marginTop || style.marginBottom) {
                    const mt = parseInt(style.marginTop),
                        mb = parseInt(style.marginBottom);
                    if(mt >= marginHighlight.MIN_MARGIN || mb >= marginHighlight.MIN_MARGIN) {
                        new marginHighlight(item, mt, mb);
                    }
                }
            });
            
        }
    },
    mounted() {
        
    }
});